import React from 'react';
import { useState, useRef, useEffect } from 'react';
import Svg from '../shared/Svg';
import PropTypes from 'prop-types';
import './Dropdown.scss';


export const Dropdown = ({ dropdownOptions = [], callback }) => {
  const [isOpen, toggleOpen] = useState(false);
  const wrapperRef = useRef(null);

  const onchangeSelect = (selectedOption) => {
    callback(selectedOption);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        toggleOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const dropdownIconPath = isOpen ? '/assets/ellipsesFocus.svg' : '/assets/ellipses.svg';
  return (
    <div className={'dropdown-container'} ref={wrapperRef}>
      <button type="button" className="dropdown-button" onClick={() => toggleOpen(!isOpen) }>
        <Svg
          className={'dropdown-itemImage'}
          data={dropdownIconPath}
        />
      </button>
      {isOpen &&
        <div className="dropdown">
          <ul>
            {dropdownOptions.map((option) =>
              <li key={option.value}
                onClick={() => onchangeSelect(option.value)}>
                <p className={'dropdown-overflow'}>{option.label}</p>
              </li>)}
          </ul>
        </div>
      }
    </div>
  );
};

Dropdown.propTypes = {
  dropdownOptions: PropTypes.array,
  callback: PropTypes.func,
};
